<template>
  <div class="slice">
    <div class="wapper">
      <el-card class="rightBox">
        <el-page-header @back="goBack" :content="tabName"></el-page-header>
        <!-- 一级药师拒绝原因字段显示 -->
        <el-card
          class="status_card"
          v-if="detailInfo.status === 3 || detailInfo.status === 4"
        >
          <div>
            <el-tag
              type="danger"
              class="prescription_type"
              effect="dark"
              size="medium"
              disable-transitions
              ><span class="prescription_status">{{
                detailInfo.status_dictText
              }}</span></el-tag
            >

            <div class="prescription_reason">
              原因：{{ detailInfo.prescriptionCause }}
            </div>
          </div>
        </el-card>
        <!-- 二级药师拒绝原因字段显示 -->
        <el-card
          class="status_card"
          v-if="detailInfo.status === 7 || detailInfo.status === 8"
        >
          <div>
            <el-tag
              type="danger"
              class="prescription_type"
              effect="dark"
              size="medium"
              disable-transitions
              ><span class="prescription_status">{{
                detailInfo.status_dictText
              }}</span></el-tag
            >

            <div class="prescription_reason">
              原因：{{ detailInfo.drugsCause }}
            </div>
          </div>
        </el-card>
        <!-- 病历详情 -->
        <caseDetail />
        <!-- 处方详情 -->
        <template v-if="Number(treatmentType) === 2 && prescriptionId">
          <div class="prescription-html">
            <span v-html="prescriptionHtml"></span>
          </div>
          <el-button
            class="back-bottom-button"
            type="primary"
            @click="goBack"
            >返回开具处方</el-button
          >
        </template>
      </el-card>
    </div>
    <Vfooter />
  </div>
</template>

<script>
import { getPrescriptionForm } from "@/api/index.js";
import caseDetail from "@/components/case/detaiInfo";
import Vfooter from "@/components/footer/index";
import prescriptionPdf from "@/components/prescriptionPdf";
export default {
  components: { prescriptionPdf, Vfooter, caseDetail },
  props: {},
  data() {
    return {
      tabName: "病历详情",
      casesId: "",
      prescriptionId: "",
      detailInfo: {},
      prescriptionHtml: "",
      treatmentType: "",
    };
  },
  created() {
    this.casesId = this.$route.query.casesId;
    this.prescriptionId = this.$route.query.prescriptionId;
    this.treatmentType = this.$route.query.treatmentType;
    if (Number(this.treatmentType) === 2 && this.prescriptionId) {
      this.readyList();
    }
  },
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    detailHandle() {
      this.$router.push({
        path: "/index/user/prescription",
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 获取数据--处方信息
     */
    async readyList() {
      try {
        const params = {
          recipeId: this.prescriptionId,
        };
        const res = await getPrescriptionForm(params);
        if (res.code == 1) {
          this.prescriptionHtml = res.data;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.el-page-header {
  margin: 20px 0 0 0;
}

.wapper {
  padding: 20px;
  min-height: 800px;

  .leftBox {
    // flex: 0 0 60%;
  }

  .rightBox {
    // flex: 0 0 38%;
    min-height: 700px;
    margin-left: 20px;
    .back-bottom-button {
      margin: 10px auto;
      display: block;
      width: 400px;
    }
    .status_card {
      float: right;
      z-index: 100;
      display: block;
      text-align: center;
      vertical-align: middle;
      position: fixed;
      .prescription_type {
        display: inline-block;
        word-break: break-all;
        width: 100%;
      }
      .prescription_reason {
        word-break: break-all;
        text-align: left;
        padding: 8px;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
}
</style>
